import { MaintenanceWindow } from "@closerplatform/spinner-openapi";

export function getCurrentMaintenanceState(maintenanceWindows: Array<MaintenanceWindow>) {
  const now = Date.now();
  const message = maintenanceWindows.filter((mw) => mw.from < now).filter((mw) => mw.to > now).map((mw) => mw.message)[0];
  const enabled = !!message;
  return { message, enabled };
}
